module.exports = __webpack_public_path__ + "media/assets/img/products/studio_auto-selected-cc23b9e8e676614b7c72f0b2fb7862f7.svg";